import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import MobileView from '../utils/MobileView'
import BrowserView from '../utils/BrowserView'
import Menu from './Menu'

const Container = styled.div`
  display: grid;
  grid-template-columns: 260px 1fr 320px;
  grid-gap: ${props => props.theme.spacing(3)}px;
`

const Drawer = styled.div`
  flex: 1 0 auto;
  height: calc(100vh - 64px);
  width: 260px;
  display: flex;
  position: sticky;
  top: 64px;
  outline: none;
  overflow-y: auto;
  background-color: ${props => props.theme.palette.background.paper};
  border-right: 1px solid ${props => props.theme.palette.divider};
  flex-direction: column;
`

const MainContainer = styled.div`
  padding: 0 20px 10px 20px;

  @media (max-width: 768px) {
    padding: 0 0 10px 0;
  }
`

const LayoutSport = props => {
  const { children } = props

  return (
    <>
      {/*
       * Empty div that matches toolbar min height and
       * pushes content down
       */}
      <BrowserView>
        <Container>
          <Drawer>
            <Menu />
          </Drawer>
          <MainContainer>{children}</MainContainer>
        </Container>
      </BrowserView>
      <MobileView>
        <MainContainer>{children}</MainContainer>
      </MobileView>
    </>
  )
}

LayoutSport.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutSport
